import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieManagementService } from '../../account/services/cookie-management.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { AppConfig } from '../../config-service/app.config';
import { productsServiceResModel } from '../models/getProductsResponse.model';
import { VersionHelper } from '../../utility-packages/versionHelper/version-helper';

@Injectable()
export class ProductService {
  accessToken = '';

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private cookieManagementService: CookieManagementService, 
    private versionHelper: VersionHelper
  ) {}

  public getProductResult() {
    let url =
      AppConfig.settings.apiServer.url +
      'api/products?region=' +
      AppConfig.settings.city.region +
      '&version=' +
      this.versionHelper.getVersion() +
      '&lang=' +
      AppConfig.settings.apiServer.lang +
      '&authType=' +
      AppConfig.settings.apiServer.authType;

    return this.http.get(url).pipe(
      catchError((error) => {
        if (typeof error === 'string') {
          return throwError(error);
        } else {
          return throwError(this.translate.instant('DEFAULT_ERROR_MESSAGE'));
        }
      })
    );
  }

  public getProductResultObservable(): Observable<productsServiceResModel> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    let url =
      AppConfig.settings.apiServer.url +
      'api/products?region=' +
      AppConfig.settings.city.region +
      '&version=' +
      this.versionHelper.getVersion() +
      '&lang=' +
      AppConfig.settings.apiServer.lang +
      '&authType=' +
      AppConfig.settings.apiServer.authType;

    return this.http
      .get<productsServiceResModel>(url, {
        headers: headers,
        responseType: 'json',
      })
      .pipe(
        catchError((error) => {
          if (typeof error === 'string') {
            return throwError(error);
          } else {
            return throwError(this.translate.instant('DEFAULT_ERROR_MESSAGE'));
          }
        }),
      );
  }
}
